var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex just-center align-center"},[(_vm.newIsWatched)?_c('button',{on:{"click":_vm.handleToggle}},[_c('v-icon',{attrs:{"color":"#FFAB00","size":"30"}},[_vm._v(" mdi-star ")])],1):_c('button',{on:{"click":_vm.handleToggle}},[_c('v-icon',{attrs:{"color":"#FFAB00","size":"30"}},[_vm._v(" mdi-star-outline ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }